export default __webpack_public_path__ + "static/media/login-bg-22.fbc74968.jpg";